import React from "react";

export interface FlyInWarningsProps {
  warnings: string[];
}

const FlyInWarnings: React.FC<FlyInWarningsProps> = ({ warnings }) => {
  if (!warnings || warnings.length == 0) return <></>;

  return (
    <i className="fas fa-exclamation-circle">
      <div className="tooltip tooltip--different-day">
        <span
          className="tooltip__title"
          dangerouslySetInnerHTML={{ __html: warnings.join("<br />") }}
        ></span>
      </div>
    </i>
  );
};

export default FlyInWarnings;
